import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/vendor-portal/vendor-cta.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundPosition: "center top",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={9} lg={8} xl={7} xxl={7}>
            <h2>Looking to Simplify Your Vendor Management Process?</h2>
            <p>
              Our custom vendor portals streamline communication, automate
              tasks, and give you full control over vendor relationships.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Discuss Your Project Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
